import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import React, { useEffect } from "react";
import PropTypes from 'prop-types'; // Corrigindo erros de Eslint

const Main = (props) => {

  const styles = `
  .Main_container {
  height: 100%;
  width: 100%;
  display: flex;
  }
  .Main_headerSearch {
  display: none;
  }
  button {
  background: transparent;
  border: 0;
  padding: 0;
  cursor: pointer;
  }
  .Main_sidebar {
  display: none;
  }
  .Main_menuitemLink {
  display: none;
  }
  .Main_menuProfile {
  display: none;
  }
  .Main_content {
  height: 100%;
  width: 100%;
  overflow-y: auto;
  }
  .Main_right {
  flex: 1;
  }
  .Main_header {
  display: none;
  }
  @media only screen and (max-width: 850px) {
  .Main_content {
    margin-left: 0;
  }
  .Main_right {
    width: 100%;
  }
  .Main_header {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 10px;
    position: fixed;
    top: 0;
    background-color: #ffffff;
    z-index: 999;
  }
  }
  .circle-icon {
  margin-left: 0.36%;
  margin-right: 0.73%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  width: 3.40%;
  height: 3.40%;
  border-radius: 50%;
  background-color: #65b6f8;
  color: rgb(243, 244, 250);
  font-size: 1.9%;
  }
    `;

    useEffect(() => {
      const styleSheet = document.createElement("style");
      styleSheet.type = "text/css";
      styleSheet.innerText = styles;
      document.head.appendChild(styleSheet);
  
      return () => {
        document.head.removeChild(styleSheet);
      };
    }, [styles]);


  const { children } = props;
  const isOpen = false;

  return (
    <>
      <div className="Main_container">
        <div className="Main_right">
          <div className={`Main_header ${isOpen ? "open" : ""}`}>
            <div className="Main_headerRight">
              <div
                className="Main_headerSearch"
              >
                <FontAwesomeIcon
                  className="icon"
                  icon={faRightFromBracket}
                />
              </div>
            </div>
          </div>
          <div
            className="Main_content"
            style={{ marginTop: "30px", marginLeft: "-10px" }}
          >
            {children}
          </div>
        </div>
      </div>
    </>
  );
};

Main.propTypes = { // Corrigindo erros de Eslint
  children: PropTypes.node.isRequired,
};

export default Main;
